
import API from '../config/api.js'

export const AuthService = {    
  
    login(data) {
        return API.post('/api/member/login', data);
    },

    login1(data) {
        return API.post('/api/member/login1', data);
    },

    register(data) {
        return API.post('/api/member/create', data);
    },

    logout(){
        return API.post('/api/logout');
    },

    reset(data){
        return API.post('/api/forgot-password', data);        
    },

    getProfile(){        
        return API.get('/api/user/profile');
    },
   
    updatePassword(data) {    
        return API.patch(`api/member/password`, data);
    }, 
    
    getUserRoles() {    
        return API.get(`api/user/roles`);
    },  

    getMenuList(roleId){
        return API.get(`api/menu/${roleId}`);
    },

    updateGoogleAuth(data) {    
        return API.post(`api/update/googleAuth`, data);
    },
    getCompanySettings() {
        return API.get(`api/settings/get-company-settings`);
    },

}



